import { avatarFor } from "@/data/demo";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export const userAvatar = (u) =>
  u?.avatar_path ? `${API}/profile/avatar/${u.id}?v=${u.avatar_v || 0}` : avatarFor(u?.name);

// Resolve an author's avatar: use the logged-in user's uploaded photo when the
// author is them, otherwise the generated initials avatar.
export const pfp = (author, me) =>
  me?.avatar_path && author === me?.name
    ? `${API}/profile/avatar/${me.id}?v=${me.avatar_v || 0}`
    : avatarFor(author);
